export const setSendingProtoTasksFailed = ({ reason }): Function => (
  state,
): void => {
  return {
    ...state,
    scheduling: {
      ...state.scheduling,
      lastFetch: {
        failed: true,
        lastFailure: Date.now(),
        reason,
      },
      sending: false,
    },
  };
};
